import { Avatar, Tooltip } from '@mui/material';
import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

type DebitCreditStatusProps = {
    isCredit: boolean;
};
const DebitCreditStatus: FC<DebitCreditStatusProps> = ({ isCredit }: DebitCreditStatusProps) => {
    const { t: translate } = useTranslation(['invoices']);

    return (
        <Fragment>
            {isCredit ? (
                <Tooltip title={translate('CREDIT').toString()}>
                    <Avatar
                        sx={{ bgcolor: 'warning.main', width: 24, height: 24, fontSize: '1em', paddingLeft: '1px' }}
                    >
                        {translate('CREDIT_LETTER').toString()}
                    </Avatar>
                </Tooltip>
            ) : (
                <Tooltip title={translate('DEBIT').toString()}>
                    <Avatar sx={{ bgcolor: 'info.main', width: 24, height: 24, fontSize: '1em' }}>
                        {translate('DEBIT_LETTER').toString()}
                    </Avatar>
                </Tooltip>
            )}
        </Fragment>
    );
};

export default DebitCreditStatus;
